export default __webpack_public_path__ + "static/media/404.9d1830e3.png";